export default __webpack_public_path__ + "static/media/regulatory--go-straight-or-turn-left--g1.78963e27.png";